<div class="flex h-full w-full items-center pl-[18px]" [attr.data-pendo-id]="pendoId">
  {{ params.value }}
</div>
